import { render, staticRenderFns } from "./BillVatInvoiceInfo.vue?vue&type=template&id=3c1d8074&"
import script from "./BillVatInvoiceInfo.vue?vue&type=script&lang=js&"
export * from "./BillVatInvoiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports